import React, { useCallback } from 'react'
import type { BlogPostTagResult } from '../../data/BlogPostTagFragment'
import type { BodyTagResult } from '../../data/BodyTagFragment'
import type { ItemSubCategoryPreviewResult } from '../../data/ItemSubCategoryFragment'
import { Tag } from './Tag'
import style from './TagRow.module.sass'

type TagRowProps = {
	tags: ItemSubCategoryPreviewResult[] | BodyTagResult[] | BlogPostTagResult[]
}

export const TagRow = React.memo(function TagRow(props: TagRowProps) {
	const checkType = useCallback((tag: ItemSubCategoryPreviewResult | BodyTagResult | BlogPostTagResult) => {
		if ('flavorCategory' in tag) {
			return tag.flavorCategory?.color?.colorHex
		}
		if ('category' in tag) {
			return tag.category?.color?.colorHex
		}
		if ('color' in tag) {
			return tag.color?.colorHex
		}
	}, [])

	return (
		<div className={style.row}>
			{props.tags.map((tag) => (
				<Tag key={tag.id} tag={tag} label={tag.name} color={checkType(tag)} />
			))}
		</div>
	)
})
